import { TrendingUp } from "lucide-react";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../components/ui/chart";

interface AreaChartComponentProps {
  data: any[];
  loading: boolean;
  title?: string;
  description?: string;
  chartLabel?: string;
  className?: string; // Add className prop
}

export function AreaChartComponent({
  data,
  loading,
  title = "Recycled Quantities",
  description = "Total quantities recycled in the last 90 days",
  chartLabel = "Total Quantities",
  className = "", // Default value for className
}: AreaChartComponentProps) {
  // Chart config with optional label
  const chartConfig = {
    total_quantities: {
      label: chartLabel, // Use the prop value
      color: "hsl(var(--chart-1))",
    },
  } satisfies ChartConfig;

  return (
    <Card className={`h-full ${className}`}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-56 w-full">
          {loading ? (
            <div className="w-full h-full bg-gray-200 animate-pulse rounded-xl" />
          ) : (
            <AreaChart
              accessibilityLayer
              data={data}
              margin={{
                left: 12,
                right: 12,
              }}
            >
              <CartesianGrid vertical={false} />
              <XAxis
                dataKey="date"
                tickLine={false}
                axisLine={false}
                tickMargin={8}
                tickFormatter={(value) => value.slice(5)}
              />
              <ChartTooltip
                cursor={false}
                content={<ChartTooltipContent indicator="line" />}
              />
              <Area
                dataKey="total_quantities"
                type="natural"
                fill="var(--color-total_quantities)"
                fillOpacity={0.4}
                stroke="var(--color-total_quantities)"
              />
            </AreaChart>
          )}
        </ChartContainer>
      </CardContent>
      <CardFooter>
        <div className="flex w-full items-start gap-2 text-sm">
          <div className="grid gap-2">{/* Optional footer content */}</div>
        </div>
      </CardFooter>
    </Card>
  );
}
